<template>
  <el-container id='wrapper'>
    <el-header>
      <PageTitle title="Time Log"></PageTitle>
    </el-header>
    <el-main class='main'>
      <div class="container" :class="{'entries-are-selected': selectedEntries}">
        <UserSelector v-if="$store.getters.adminMode" includeEveryone></UserSelector>
        <TimeLogTable v-bind="$props" ref="timeLogTable" class="time-log-table"></TimeLogTable>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageTitle from '../components/PageTitle'
import TimeLogTable from '../components/TimeLogTable'
import UserSelector from '../components/UserSelector'

export default {
  props: [
    'activities',
    'users'
  ],
  components: {
    PageTitle,
    TimeLogTable,
    UserSelector
  },
  computed: {
    selectedEntries () {
      let selectedEntries = this.$store.getters.filteredEntries.filter(entry => entry.selected)

      return selectedEntries.length > 0
    }
  }

}
</script>

<style lang='scss' scoped>
@import "../styles/common.scss";
.main {
  display: flex;
  align-items: stretch;
  padding-top: 0px;



  .container {
    &.entries-are-selected{
      border: 1.5px solid $warning-color;  
      transition: border .75s;
    }
    transition: border 1s;
    border: 1.5px solid white;
    display: flex;
    align-items: stretch;
    background-color: white;
    border-radius: 10px;
  }
  .time-log-table{
    flex-grow: 1;
  }
}

</style>